module.exports = __webpack_public_path__ + "static/img/17.34d1de8b.png";